import { render, staticRenderFns } from "./VisaDocuments.vue?vue&type=template&id=56640212&"
import script from "./VisaDocuments.vue?vue&type=script&lang=js&"
export * from "./VisaDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports